export default {

  addToCart: "Add to Cart",
  stock: "Stock",
  outOfStock: "Out of Stock",
  toman: "Toman",
  noProducts:"No products found",


  urls:{
    ProductCategory:"/en/product-category",
    Product:"/en/product",

  }
};
